<template>
  <div>
    <div class="table-title">ADM设备状态</div>
    <el-table
      :data="deviceStates"
      :cell-class-name="tableCellClassName"
      size="small"
      max-height="450"
      stripe border>
      <el-table-column
        min-width="250"
        label="孔号">
        <template slot-scope="scope">
          <el-link @click="navigateToProfile(scope.row)">
            <i class="el-icon-search"></i>
            {{displayName(scope.row)}}
          </el-link>
        </template>
      </el-table-column>

      <!-- @2020-04-29 数据主动上传，网络状态全部无脑绿 -->
      <el-table-column
        :formatter="stateFormatter"
        prop="onlineState"
        width="80"
        label="网络状态">
        正常
      </el-table-column>

      <el-table-column
        width="80"
        label="采集状态">
        <template slot-scope="scope">
          <span>{{stateContent(scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="200"
        label="当前变形值（毫米）">
        <template slot-scope="scope">
          <span style="color: #666;">A：</span>
          <span>{{toFixed(scope.row.offsetA) || 0}}</span>
          <span style="color: #666;">，B：</span>
          <span>{{toFixed(scope.row.offsetB) || 0}}</span>
          <br>
          <span style="color: #666;">预警值：{{toFixed(scope.row.exceedThreshold) || 0}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { toFixed } from '@/utils/helpers';

export default {
  props: ['deviceStates'],
  computed: {
    ...mapState('project', ['projects']),
    ...mapGetters('admin', ['fakeState']),
  },
  methods: {
    toFixed,
    stateFormatter(row, column, cellValue) {
      return cellValue ? '正常' : '异常';
    },
    exceedFormatter(row, column, cellValue) {
      return cellValue && cellValue.toFixed(3);
    },
    tableCellClassName({ row, column }) {
      if (column.label === '孔号') {
        return '';
      }
      if (this.fakeState) {
        return 'success-cell';
      }
      if (column.label === '网络状态') {
        if (row.onlineState) return 'success-cell';
        // @2020-04-29 因为主动上传数据没心跳包，所以全部设置为正常
        // return 'warning-cell';
        return 'success-cell';
      }
      if (column.label === '采集状态') {
        if (row.collectState) return 'success-cell';
        return 'warning-cell';
      }
      if (column.label === '当前变形值（毫米）') {
        if (!row.exceedState) return 'danger-cell';
        if (row.exceedValue >= row.exceedThreshold * 0.75) return 'warning-cell';
        return 'success-cell';
      }
      return '';
    },
    navigateToProfile(row) {
      const project = this.projects.find(p => p.id === row.projectId);
      this.$store.dispatch('project/changeProject', { project });
      this.$router.push({ name: 'profiles', params: { deviceId: row.name } });
    },
    displayName(row) {
      if (row.Branch && row.Branch.name) {
        return `${row.Branch.name} / ${row.deviceName}`;
      }
      return row.deviceName;
    },
    stateContent(row) {
      if (this.fakeState) return '正常';
      return row.collectState ? '正常' : '异常';
    },
  },
};
</script>

